export const SOURCE_OPTIONS = [
  { value: 'pagina-web', label: 'Página web' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'chile-autos', label: 'Chile autos' },
  { value: 'terreno', label: 'Terreno' },
  { value: 'whatsapp-ai', label: 'WhatsApp · Sofía' },
  { value: 'whatsapp-handoff', label: 'WhatsApp · Sofía (derivado)' },
  { value: 'otros', label: 'Otros' },
];

export const CONTACT_METHOD_OPTIONS = [
  { value: 'telefono', label: 'Teléfono' },
  { value: 'correo-electronico', label: 'Correo electrónico' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'terreno', label: 'Terreno / Piso' },
  { value: 'otros', label: 'Otros' },
];

export const STATE_OPTIONS = [
  { value: 'new', label: 'Nuevo' },
  { value: 'assigned', label: 'Asignado' },
  { value: 'negotiation', label: 'Negociación' },
  { value: 'visit', label: 'Visita' },
  { value: 'close', label: 'Cerrado' },
  { value: 'completed', label: 'Completado' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'contado', label: 'CONTADO' },
  { value: 'tarjeta-debito', label: 'TARJETA DE DÉBITO' },
  { value: 'tarjeta-credito', label: 'TARJETA DE CRÉDITO' },
  { value: 'cheque', label: 'CHEQUE' },
  { value: 'credito', label: 'CRÉDITO' },
  { value: 'otro', label: 'OTRO' },
];

export const DOCUMENT_TYPE_OPTIONS = [
  { value: 'factura', label: 'Factura' },
  { value: 'contrato', label: 'Contrato' },
];
